<div class="d-flex justify-content-between align-items-center">
  <span class="info-label" *ngIf="showLabel">{{'customer.totalDebt' | translate}}</span>
  <h4>
    <span class="badge rounded" [ngClass]="{'bg-danger':balance>0,'bg-info':balance==0}">
      {{ balance | thousandSeparatorWithDecimals}}
    </span>
  </h4>
</div>